export default __webpack_public_path__ + "static/media/cheese.b06ef4c4.png";